// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useMemo} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {App_context} from 'hola_app_context';
import {use_app_context} from '../../../../toolip/pub/lib/app_context';
import {use_plans} from '../plans/plans';
import {Proxy_type} from '../../../../hola/pub/ui/pro/cp/orders';
import {generate_product_cards_data, type t_card_data} from './buy_cards';
import styles from './lobby_cards.module.less';
import hola_opt, {www_hola} from 'hola_opt';
import {useHistory} from 'react-router-dom';
import {proxy_titles} from './pricing_lobby';
import {Button} from '../../../../hola/pub/lib/button';
import {use_qs_with_set} from '../../../../hola/pub/lib/use_qs';
import Check_green from '../../img/icons/16/check_green.svg';
import Icon_check_circle from '../../img/icons/16/check_circle_color.svg';
import {product_features} from '../products';

const Status_banner = ({type, is_all_sold_out}: {
    type: Proxy_type;
    is_all_sold_out: boolean;})=>{
    const {theme} = useContext(Settings_context);
    const is_kyc = type == Proxy_type.EV_RES;
    const banner_text = is_kyc ?
        cn(theme.p14, theme.color_success300, theme.med) :
        cn(theme.p12, theme.color_warn300);
    if (!is_all_sold_out && !is_kyc)
        return null;
    const text = is_kyc ? 'KYC verification required' : 'ALL SOLD OUT!';
    return <div className={cn(styles.status_banner,
      is_kyc ? styles.info_banner : styles.alert_banner)}>
      <div className={styles.banner_content}>
        {is_kyc && <Icon_check_circle className={styles.banner_icon}/>}
        <p className={banner_text}>{text}</p>
      </div>
    </div>;
};

const Check_cube = ({text})=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.check_cube}>
      <Check_green/>
      <p className={cn(theme.p12, theme.med)}>{text}</p>
    </div>;
};

const Lobby_checks = ({check_list = []})=>{
    return <div className={styles.checks_wrapper}>
      <div className={styles.checks_container}>
        {check_list.map((check, index)=>{
          const text = product_features[check];
          return text ? <Check_cube key={index} text={text} /> : null;
        })}
      </div>
    </div>;
};

const Price_card = ({card, type, is_all_sold_out, is_sold_out, set_modal}:
    {card: t_card_data; type: Proxy_type, is_all_sold_out: boolean;
    is_sold_out: boolean;
    set_modal?: (id: string, plan_id?: string)=>void;})=>{
    const {theme} = useContext(Settings_context);
    const {dashboard} = use_app_context();
    const {dispatch} = dashboard;
    const history = useHistory();
    const is_disabled = is_all_sold_out || is_sold_out;
    const button_caption = card.badge?.free ? 'Start now' : 'Buy now';
    const button_color = is_disabled ? 'transparent' :
        card.badge?.free ? 'orchid' :
        card.badge?.popular ? 'primary' :
        'transparent';
    const handle_buy_click = ()=>{
      if (type == Proxy_type.RES && set_modal)
          set_modal('read_only', card.plan_id);
      else
          history.push(`/pricing/checkout?plan_id=${card.plan_id}`);
    };
    return <div
      className={cn(
        styles.price_card,
        is_disabled && styles.sold_out,
        !is_disabled && card.badge?.popular && styles.popular_card,
        !is_disabled && card.badge?.popular && styles[card.badge.color],
        !is_disabled && card.badge?.free && styles.free_card
      )}>
      <div className={styles.desktop_layout}>
        <div className={styles.left_content}>
          <div className={styles.amount_wrapper}>
            <p className={cn(theme.p16, theme.bold,
              is_disabled ? theme.color_n400 : theme.color_n700)}>
              {card.amount}
            </p>
            {!is_all_sold_out && (is_sold_out || card.badge) &&
              <div className={cn(
                styles.badge,
                is_sold_out ? styles.sold_out_badge :
                card.badge?.popular &&
                styles[`popular_badge_${card.badge.color}`],
                card.badge?.free && styles.free_badge
              )}>
                {is_sold_out ? 'SOLD OUT!' : card.badge.text}
              </div>
            }
          </div>
        </div>
        <div className={styles.right_content}>
          <div className={styles.price_section}>
            <p className={cn(theme.p20, theme.bold,
              is_disabled ? theme.color_n400 : theme.color_n700)}>
              {card.price}
            </p>
            <p className={cn(theme.p14, theme.reg,
              is_disabled ? theme.color_n400 : theme.color_n700)}>
              {card.billed}
            </p>
          </div>
          {card.badge?.free ?
            <Button caption={button_caption} color={button_color} round={false}
              size="xs"
              on_click={()=>{
                dispatch({type: 'create_free_zone', payload: {type}});
                history.push('/dashboard/page/plans');
              }}
              cls={cn(styles.btn, is_disabled && styles.sold_out_btn)}
            />
          :
            <Button caption={button_caption} color={button_color} round={false}
              size="xs"
              on_click={handle_buy_click}
              cls={cn(styles.btn, is_disabled && styles.sold_out_btn)}
            />
          }
        </div>
      </div>
      <div className={styles.mobile_layout}>
        <div className={styles.mobile_left}>
          <p className={cn(theme.p16, theme.bold,
            is_disabled ? theme.color_n400 : theme.color_n700)}>
            {card.amount}
          </p>
          <div className={styles.mobile_price_section}>
            <p className={cn(theme.p20, theme.bold,
              is_disabled ? theme.color_n400 : theme.color_n700)}>
              {card.price}
            </p>
            <p className={cn(theme.p14, theme.reg,
              is_disabled ? theme.color_n400 : theme.color_n700)}>
              {card.billed}
            </p>
          </div>
        </div>
        {!is_all_sold_out && (is_sold_out || card.badge) &&
          <div className={cn(
            styles.badge,
            styles.mobile_badge,
            is_sold_out ? styles.sold_out_badge :
            card.badge?.popular && styles[`popular_badge_${card.badge.color}`],
            card.badge?.free && styles.free_badge
          )}>
            {is_sold_out ? 'SOLD OUT!' : card.badge.text}
          </div>
        }
        <div className={styles.mobile_button}>
          {card.badge?.free ?
            <Button caption={button_caption} color={button_color} round={false}
              size="xs"
              on_click={()=>{
                dispatch({type: 'create_free_zone', payload: {type}});
                history.push('/dashboard/page/plans');
              }}
              cls={cn(styles.btn, is_disabled && styles.sold_out_btn)}
            />
          :
            <Button caption={button_caption} color={button_color} round={false}
              size="xs" to={`/pricing/checkout?plan_id=${card.plan_id}`}
              cls={cn(styles.btn, is_disabled && styles.sold_out_btn)}
            />
          }
        </div>
      </div>
    </div>;
};

const More_plans_card =
    ({type, last_amount}: {type: Proxy_type; last_amount: string})=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.more_plans_card}>
      <div className={styles.info}>
        <p className={cn(theme.p14, theme.bold, theme.color_n700)}>
          Need more than {last_amount}?
        </p>
        <p className={cn(theme.p14, theme.reg, theme.color_n600)}>
          Explore full {proxy_titles[type]} Proxies pricing options
        </p>
      </div>
      <Button caption="More plans" color="transparent" round={false} size="xs"
        to={`/pricing/${type}`} cls={styles.btn}/>
  </div>;
};

interface i_lobby_cards_props {
    selected_type: Proxy_type;
    set_modal?: (id: string, plan_id?: string)=>void;
}

export const Lobby_cards = (props: i_lobby_cards_props)=>{
    const {is_client} = useContext(App_context);
    const oculus_plans = use_plans();
    const {show_free_zone_promo} = use_app_context();
    const {selected_type, set_modal} = props;
    const {qs} = use_qs_with_set();
    const current_period = qs.period == '1m' ? '1 M' : '1 W';
    const product_cards_data = useMemo(()=>{
        const data =
            generate_product_cards_data(oculus_plans, show_free_zone_promo);
        if (www_hola.pricing_types_with_period.includes(selected_type) &&
          current_period)
        {
            data[selected_type].cards = data[selected_type].cards.filter(
                card=>card.period == current_period || card.plan_id == 'free');
        }
        return data;
    }, [oculus_plans, show_free_zone_promo, current_period, selected_type]);
    if (!is_client)
        return null;
    const {cards = [], checks = []} =
        product_cards_data[selected_type] || {};
    const display_cards = cards.slice(0, 4);
    const last_amount = display_cards[display_cards.length - 1]?.amount;
    const is_all_sold_out = selected_type == Proxy_type.ISPPREM ||
        selected_type == Proxy_type.EV_ISP ?
        hola_opt.oculus_zones_availability[selected_type] <
        Math.min(...cards.map(c=>parseInt(c.amount))) : false;
    const is_sold_out = card=>{
        if (selected_type !== Proxy_type.ISPPREM &&
            selected_type !== Proxy_type.EV_ISP)
        {
            return false;
        }
        if (is_all_sold_out)
            return true;
        const amount = parseInt(card.amount);
        return hola_opt.oculus_zones_availability[selected_type] < amount;
    };
    return <div className={styles.lobby_cards}>
      <Status_banner type={selected_type} is_all_sold_out={is_all_sold_out}/>
      {display_cards.map((card, index)=>
          <Price_card
            key={index}
            card={card}
            type={selected_type}
            is_sold_out={is_sold_out(card)}
            is_all_sold_out={is_all_sold_out}
            set_modal={set_modal}
          />
      )}
      {!is_all_sold_out &&
        <More_plans_card type={selected_type} last_amount={last_amount}/>
      }
      <Lobby_checks check_list={checks}/>
    </div>;
};
